import { render, staticRenderFns } from "./vsPagination.vue?vue&type=template&id=10825b49"
import script from "./vsPagination.vue?vue&type=script&lang=js"
export * from "./vsPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports